(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqaccordion"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initFaqAccordion(root) {
    if (root.dataset.faqInitialized) return;
    root.dataset.faqInitialized = 'true';

    var allowMultiple = root.dataset.allowMultiple === 'true';
    var triggers = root.querySelectorAll('.faq-accordion__trigger');

    function getPanel(trigger) {
      return document.getElementById(trigger.getAttribute('aria-controls'));
    }

    function expand(trigger) {
      var panel = getPanel(trigger);
      if (!panel) return;
      trigger.setAttribute('aria-expanded', 'true');
      panel.style.height = panel.scrollHeight + 'px';

      function onEnd(e) {
        if (e.propertyName !== 'height') return;
        panel.style.height = 'auto';
        panel.removeEventListener('transitionend', onEnd);
      }
      panel.addEventListener('transitionend', onEnd);
    }

    function collapse(trigger) {
      var panel = getPanel(trigger);
      if (!panel) return;
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          panel.style.height = '0px';
        });
      });
      trigger.setAttribute('aria-expanded', 'false');
    }

    triggers.forEach(function (trigger) {
      var panel = getPanel(trigger);
      if (!panel) return;
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';
      panel.style.height = isOpen ? panel.scrollHeight + 'px' : '0px';

      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';

        if (!expanded && !allowMultiple) {
          triggers.forEach(function (other) {
            if (other !== trigger && other.getAttribute('aria-expanded') === 'true') {
              collapse(other);
            }
          });
        }

        expanded ? collapse(trigger) : expand(trigger);
      });
    });
  }

  document.querySelectorAll('[data-faq-accordion]').forEach(initFaqAccordion);

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-faq-accordion]');
    if (root) initFaqAccordion(root);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var trigger = event.target.querySelector('.faq-accordion__trigger');
    if (trigger && trigger.getAttribute('aria-expanded') !== 'true') {
      trigger.click();
    }
  });
})();

  } catch(e) { console.error(e); }
})();
})();
